export const environment = {
    production: false,
    local: false,
    appSessionUniqueId: "973F76C621BF8",
    userSessionUniqueId: "D1AABA1DBE3F4",
    serverUrl: "https://heliloghtlapi.rrsolutionstest.it/api/frontend/",
    imageServerUrl: "https://helilogimages.rrsolutionstest.it/",
    turnstileSiteKey: "0x4AAAAAACTPRDDfaielARd7",
    aiApiUrl: "https://aiapi.helilog.rrsolutionstest.it/api/v1",
};
